export default {"src":"/_next/static/media/checkCircleIcon.c46f8e1e.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};